import React from 'react';
import styled, { css } from 'styled-components';
import { GetColor, Icon, Shimmer } from 'venn-ui-kit';
import { OBJECTIVE_SELECTOR_HEIGHT } from './DoubleObjectiveSelector';
import { cn } from '@/lib/utils';

export const DoubleObjectiveSelectorLoader = () => (
  <div className={`h-[${OBJECTIVE_SELECTOR_HEIGHT}px] rounded-[113px] border border-solid border-venn-grey-20 flex`}>
    <PrimaryPillLoader>
      <Icon type="function" />
    </PrimaryPillLoader>
    <div
      className={cn([
        `w-[25px] border-0 border-x border-solid border-x-venn-grey-20 h-[${OBJECTIVE_SELECTOR_HEIGHT - 2}px]`,
        'flex items-center justify-center',
      ])}
    >
      <Icon type="plus" className="text-venn-grey-50" />
    </div>
    <SecondaryPillLoader />
  </div>
);

const HalfPillCss = css`
  height: ${OBJECTIVE_SELECTOR_HEIGHT - 2}px;

  display: flex;
  align-items: center;

  i {
    margin-left: 10px;
    color: ${GetColor.GreyScale.Grey50};
  }
`;

const PrimaryPillLoader = styled.div`
  ${HalfPillCss}
  ${Shimmer}
  animation-duration: 7s;
  border-radius: 113px 0 0 113px;
  width: 130px;
`;

const SecondaryPillLoader = styled.div`
  ${HalfPillCss}
  ${Shimmer}
  animation-duration: 7s;
  border-radius: 0 113px 113px 0;
  width: 150px;
`;
